import React from 'react'
import cn from 'classnames'

import { useTranslation } from '@mc/i18n'

import { HIW2, HIW3, HIW4 } from 'pages/sessions/shared/Icons'
import classes from './styles.module.scss'

const ICON_CONTAINER_SIZE = 50

export const Bullets = ({ gteSM }: { gteSM: boolean }) => {
  const { t } = useTranslation('@mc/next')

  const bulletPoints = [
    {
      Icon: HIW2,
      text: t('sessions.activeParticipationSection.peersAssistantItem'),
    },
    {
      Icon: HIW4,
      text: t('sessions.activeParticipationSection.communityItem'),
    },
    {
      Icon: HIW3,
      text: t('sessions.activeParticipationSection.questionsAnsweredItem'),
    },
  ]

  return (
    <div
      className={cn(
        classes.bulletPointSection,
        'd-flex justify-content-center mc-corners--sm',
        {
          'mc-px-12': gteSM,
          'mc-px-4': !gteSM,
        },
      )}
    >
      <div className='mc-my-9'>
        {bulletPoints.map(({ Icon, text }, index) => (
          <div
            key={index}
            className={cn('d-flex', {
              [gteSM ? 'mc-mb-6' : 'mc-mb-8']: !(
                index ===
                bulletPoints.length - 1
              ),
              'flex-column align-items-center': !gteSM,
            })}
          >
            <Icon height={ICON_CONTAINER_SIZE} width={ICON_CONTAINER_SIZE} />
            <div
              className={cn(
                'd-flex align-items-center mc-text-large',
                { 'mc-text--center mc-mt-3': !gteSM },
                { 'mc-ml-5': gteSM },
              )}
            >
              {text}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
